import { render, staticRenderFns } from "./FightReportHistory.vue?vue&type=template&id=5cbb8986&scoped=true"
import script from "./FightReportHistory.vue?vue&type=script&lang=js"
export * from "./FightReportHistory.vue?vue&type=script&lang=js"
import style0 from "./FightReportHistory.vue?vue&type=style&index=0&id=5cbb8986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb8986",
  null
  
)

export default component.exports